import { WarningsReportItemRows } from './types';
import WarningItemRow from './warning-item-row';

const WarningItemRows = ({
  setShowDetalisation,
  maxCount,
  warningsNumbersOfAlerts,
  filtersLength,
  isLoading,
  organizationDetails,
}: WarningsReportItemRows) => (
  <div>
    <WarningItemRow
      title="Customers block lists ongoing monitoring"
      warningItem={
        warningsNumbersOfAlerts?.totals?.customersBlockListOngoingMonitoring
      }
      maxCount={maxCount}
      filteredWarningItem={
        filtersLength && filtersLength > 0 && !isLoading
          ? warningsNumbersOfAlerts?.filteredTotals
              ?.customersBlockListOngoingMonitoring
          : undefined
      }
      organizationDetails={organizationDetails}
    />
    <WarningItemRow
      title="Transactions block lists monitoring"
      warningItem={
        warningsNumbersOfAlerts?.totals?.transactionsBlockListsMonitoring
      }
      maxCount={maxCount}
      filteredWarningItem={
        filtersLength && filtersLength > 0 && !isLoading
          ? warningsNumbersOfAlerts?.filteredTotals
              ?.transactionsBlockListsMonitoring
          : undefined
      }
      organizationDetails={organizationDetails}
    />
    <WarningItemRow
      title="Transactions risk scoring"
      warningItem={
        warningsNumbersOfAlerts?.totals?.transactionsRiskScoringMonitoring
      }
      maxCount={maxCount}
      filteredWarningItem={
        filtersLength && filtersLength > 0 && !isLoading
          ? warningsNumbersOfAlerts?.filteredTotals
              ?.transactionsRiskScoringMonitoring
          : undefined
      }
      organizationDetails={organizationDetails}
    />
    <WarningItemRow
      title="Transactions monitoring rules"
      warningItem={warningsNumbersOfAlerts?.totals?.transactionsMonitoringRules}
      maxCount={maxCount}
      setShowDetalisation={setShowDetalisation}
      filteredWarningItem={
        filtersLength && filtersLength > 0 && !isLoading
          ? warningsNumbersOfAlerts?.filteredTotals?.transactionsMonitoringRules
          : undefined
      }
      organizationDetails={organizationDetails}
      withIcon
    />
    <WarningItemRow
      title="Payment orders block lists monitoring"
      warningItem={
        warningsNumbersOfAlerts?.totals?.paymentsOrdersBlocklistsMonitoring
      }
      maxCount={maxCount}
      filteredWarningItem={
        filtersLength && filtersLength > 0 && !isLoading
          ? warningsNumbersOfAlerts?.filteredTotals
              ?.paymentsOrdersBlocklistsMonitoring
          : undefined
      }
      organizationDetails={organizationDetails}
    />
    <WarningItemRow
      title="Payment orders monitoring rules"
      warningItem={
        warningsNumbersOfAlerts?.totals?.paymentsOrdersMonitoringRules
      }
      maxCount={maxCount}
      filteredWarningItem={
        filtersLength && filtersLength > 0 && !isLoading
          ? warningsNumbersOfAlerts?.filteredTotals
              ?.paymentsOrdersMonitoringRules
          : undefined
      }
      organizationDetails={organizationDetails}
    />
    <WarningItemRow
      title="Agreements"
      warningItem={warningsNumbersOfAlerts?.totals?.transactionsAgreements}
      maxCount={maxCount}
      filteredWarningItem={
        filtersLength && filtersLength > 0 && !isLoading
          ? warningsNumbersOfAlerts?.filteredTotals?.transactionsAgreements
          : undefined
      }
      organizationDetails={organizationDetails}
    />
  </div>
);

export default WarningItemRows;
